import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/useAuthStore'
import { setSuppressToasts } from '@/utils/messageClient'
import { clearStaleAuthState } from '@/lib/auth/clearStaleAuthState'

/** Flag sessionStorage : évite réhydratation / double redirect juste après logout */
export const POST_LOGOUT_FLAG = 'folkyn_post_logout'

export function isPostLogoutTransition() {
  return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(POST_LOGOUT_FLAG) === '1'
}

/**
 * Hook réutilisable pour la déconnexion (cookies HttpOnly via POST /auth/logout).
 */
export function useLogout() {
  const navigate = useNavigate()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogout = useCallback(async () => {
    setIsLoggingOut(true)
    setSuppressToasts(true)
    sessionStorage.setItem(POST_LOGOUT_FLAG, '1')
    navigate('/login', { replace: true })

    try {
      await clearStaleAuthState()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      sessionStorage.removeItem(POST_LOGOUT_FLAG)
      setIsLoggingOut(false)
      setTimeout(() => setSuppressToasts(false), 300)
    }
  }, [navigate])

  return { handleLogout, isLoggingOut }
}
